import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import AssociateWineList from "@/components/products/AssociateWine/AssociateWineList.vue";
export default {
  name: "AssociateWineModal",
  props: {
    loggedUserData: Object,
    modal: {
      type: Object,
      default: function _default() {
        return {
          title: "Associate wine"
        };
      }
    },
    wineCard: {
      type: Object,
      default: function _default() {
        return {
          displaySkuInsteadOfPrice: false
        };
      }
    },
    wineFiltersStorageKey: {
      type: String,
      default: function _default() {
        return "associateWineFiltersKey";
      }
    },
    userTargetId: {
      type: Number,
      default: function _default() {
        return null;
      }
    },
    wine: {
      type: Object,
      default: function _default() {
        return {
          wineSupplierPrice: {}
        };
      }
    },
    thirdPartyUserSelector: {
      type: Object,
      default: function _default() {
        return {
          display: true
        };
      }
    },
    filtersVisibility: {
      type: Object,
      default: function _default() {
        return {};
      },
      validator: function validator(val) {
        var allowedKeys = ["showVintage", "showVintageCmpOp", "showStockQuantityMin", "showCountry", "showRegion", "showAppellation", "showDenomination", "showProducer", "showWineType", "showBottling", "showRangeAccessibilities", "showStockOnly", "showWarehouseOnly", "showSpecialDealsOnly", "showDepartureContinent"];
        return Object.keys(val).every(function (k) {
          return allowedKeys.includes(k);
        });
      }
    }
  },
  components: {
    AssociateWineList: AssociateWineList
  },
  data: function data() {
    return {
      shown: false,
      associateWineListKey: 0,
      options: {
        color: "primary",
        zIndex: 2000
      }
    };
  },
  computed: {
    getUserTargetId: function getUserTargetId() {
      if (this.userTargetId !== 0) return this.userTargetId;
      return this.loggedUserData.idUser;
    }
  },
  methods: {
    open: function open() {
      this.resetComponent();
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    resetComponent: function resetComponent() {
      this.associateWineListKey++; //force re-render
    },
    associateWine: function associateWine(wineId) {
      this.$emit("associateWine", wineId);
      this.close();
    },
    associateCloneWine: function associateCloneWine(wineId) {
      this.$emit("associateCloneWine", wineId);
      this.close();
    }
  }
};